import { IEventLoggingComponentProps } from '@AppModels/Logging';
import { Industry } from '@ViewModels';
import { StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { DefaultSupportedIndustries } from '../../../models';
import { getIndustryName } from '../../../models/UiUtils';
import { ISelectOption, MultiSelect } from '../../../web/components/DeprecatedSelect';
import { styleSheet } from './styles';

interface IProps extends IEventLoggingComponentProps {
	onSelectedIndustryOptionsChanged?(selectedOptions: ISelectOption<TemplateIndustryOption>[]): void;
	styles?: StyleDeclarationValue[];
	selectedIndustryOptions?: ISelectOption<TemplateIndustryOption>[];
	supportedIndustryOptions?: ISelectOption<TemplateIndustryOption>[];
}

export type TemplateIndustryOption = Industry | 'All';

const industriesToDropdownOptions = (industries: Industry[]): ISelectOption<TemplateIndustryOption>[] => {
	return [
		{
			dataContext: 'All',
			forceSelectAll: true,
			id: 'industry-option-all',
			text: 'All',
			type: 'checkbox',
		},
		...industries.map<ISelectOption<TemplateIndustryOption>>(x => {
			const name = getIndustryName(x);
			return {
				dataContext: x,
				id: `industry-option-${name.split(' ').join('-').toLowerCase()}`,
				text: name,
				type: 'checkbox',
			};
		}),
	];
};

export const DefaultIndustryDropdownOptions = industriesToDropdownOptions(DefaultSupportedIndustries);

export class IndustriesDropdown extends React.PureComponent<IProps> {
	public render() {
		const { selectedIndustryOptions = [], styles = [], supportedIndustryOptions } = this.props;
		const options = supportedIndustryOptions || DefaultIndustryDropdownOptions;

		return (
			<MultiSelect
				onClose={this.selectedIndustryOptionsChanged}
				options={options}
				selectAllIfNoneSelected={true}
				selectedOptions={selectedIndustryOptions}
				selectedOptionsTitle={this.renderIndustryDropdownAnchor}
				styles={[styleSheet.dropdown, ...styles]}
			/>
		);
	}

	private renderIndustryDropdownAnchor(selectedOptions: ISelectOption<TemplateIndustryOption>[]) {
		return <div>{selectedOptions.length > 1 ? 'Multiple Industries' : selectedOptions[0].text}</div>;
	}

	private selectedIndustryOptionsChanged = (selectedOptions: ISelectOption<TemplateIndustryOption>[]) => {
		this.props.onSelectedIndustryOptionsChanged?.(selectedOptions);
	};
}
